import React, { useState } from 'react'
import { Card, FloatButton, Popover, Button, Space } from 'antd'
import RubricPreview from './preview/RubricPreview'
import RubricPreviewPrint from './preview/RubricPreviewPrint'
import PrintableContent from '../../../../components/common/printable-content/PrintableContent'
import { DownloadOutlined } from '@ant-design/icons'
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle'
import { useSelector } from 'react-redux'
import assignmentSelectors from '../../../../store/selectors/assignment.selectors'

const PDF_EXPORT_VIEWS = {
    REGULAR: 'regular',
    DIFF: 'diff',
}

const RubricSection = () => {
    const assignmentName = useSelector(assignmentSelectors.name)
    useDocumentTitle(assignmentName)
    const [pdfExportView, setPdfExportView] = useState(PDF_EXPORT_VIEWS.REGULAR)
    const [popoverOpen, setPopoverOpen] = useState(false)

    const handleDownload = (view) => {
        setPdfExportView(view)
        setPopoverOpen(false)
        setTimeout(() => {
            window.print()
        }, 300)
    }

    const downloadMenu = (
        <Space direction='vertical' style={{ width: '100%' }}>
            <Button
                type='primary'
                block
                onClick={() => handleDownload(PDF_EXPORT_VIEWS.REGULAR)}
            >
                Current
            </Button>
            <Button
                block
                onClick={() => handleDownload(PDF_EXPORT_VIEWS.DIFF)}
            >
                Diff View
            </Button>
        </Space>
    )

    return (
        <Card title='Document Preview'>
            <div>
                <div className='rubric-preview-view'>
                    <RubricPreview />
                </div>
                <div className='rubric-preview-print' style={{ display: 'none' }}>
                    <PrintableContent>
                        <RubricPreviewPrint exportView={pdfExportView} />
                    </PrintableContent>
                </div>
            </div>
            <Popover
                content={downloadMenu}
                trigger='click'
                open={popoverOpen}
                onOpenChange={setPopoverOpen}
                placement='leftTop'
            >
                <FloatButton type='primary' icon={<DownloadOutlined />} title='Download' />
            </Popover>
        </Card>
    )
}

export default RubricSection
